import React, { useContext } from "react"

import { ThemeContext } from "../../ThemeProvider"
import { Icon } from "../types"

export const ClickToPayLogoIcon: React.FC<Icon> = (props) => {
    const { defaults } = useContext(ThemeContext)
    const { size = 24, color = defaults.colors.neutrals[900], ...otherProps } = props

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            color={color}
            {...otherProps}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <path
                d="M6.21053 5H3C1.89543 5 1 5.89543 1 7V17C1 18.1046 1.89543 19 3 19H8.16399C8.76014 19 9.32522 18.7341 9.70517 18.2747L14.8947 12L9.10526 5H13.1579L18.9474 12L13.1579 19H17.2105L23 12L17.2105 5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}
